export const iconFontAwesomeConstructionToolbox = (
	<i className="fa-solid fa-toolbox"></i>
);
